"use client";

import { useTour } from "@/asset-dashboard/hooks";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import {
  // faLightbulb,
  faSquareRootVariable,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonProps } from "@shadcn-ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@shadcn-ui/popover";
import { getTransitions } from "i18n";
import { FC } from "react";

import FormulaList from "./formula";

const commonButtonProps: ButtonProps = {
  className: "flex items-center gap-2",
  size: "sm",
  variant: "ghost",
};

const FormulaButton: FC = () => {
  const t = getTransitions();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button {...commonButtonProps}>
          <div>{t("asset_dashboard.calculation_formula")}</div>
          <FontAwesomeIcon icon={faSquareRootVariable} />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-full max-w-lg" side="bottom">
        <FormulaList />
      </PopoverContent>
    </Popover>
  );
};

// const OpenSourceGuideButton: FC = () => {
//   return (
//     <Button {...commonButtonProps} disabled variant="outline">
//       <div>开源指南</div>
//       <FontAwesomeIcon icon={faLightbulb} />
//     </Button>
//   );
// };
// const ThrottleGuideButton: FC = () => {
//   return (
//     <Button {...commonButtonProps} disabled variant="outline">
//       <div>节流指北</div>
//       <FontAwesomeIcon icon={faLightbulb} />
//     </Button>
//   );
// };

const TourButton: FC = () => {
  const t = getTransitions();
  const { run } = useTour();
  return (
    <Button {...commonButtonProps} onClick={run}>
      <div>{t("common.help")}</div>
      <FontAwesomeIcon icon={faQuestionCircle} />
    </Button>
  );
};

export const PageActionBar: FC = () => {
  return (
    <div className="flex items-center gap-2">
      <FormulaButton />
      <TourButton />
      {/* <OpenSourceGuideButton />
      <ThrottleGuideButton /> */}
    </div>
  );
};
